import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import ErrorMessage from "components/ErrorMessage";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";

const EditBackgroundCheckPricing = ({ setEditShowModal, getAllBackgroundCheckPricing, item }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      name: item?.name,
      price: item?.price,
    },
  });
  const notification = useToastContext();

  const onSubmit = async (data) => {
    try {
      data.name = data?.name?.trim();
      data.price = Number(data?.price);
      const path = apiPath.getBackgroundCheckPricing + "/" + item._id;
      const result = await apiPut(path, data);
      if (result?.data?.success) {
        notification.success(result?.data?.message);
        getAllBackgroundCheckPricing();
        setEditShowModal(false);
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.error("error in update background check pricing==>>>>", error.message);
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form onSubmit={handleSubmit(onSubmit)} className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("EDIT_BACKGROUND_CHECK_PRICING")}</h3>
                <button
                  type="button"
                  className="ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setEditShowModal(false)}
                >
                  <span className="text-[#B8BBBF] text-4xl">×</span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  {/* Check Name */}
                  <div className="relative z-0 mb-6 w-full">
                    <input
                      autoFocus
                      maxLength={100}
                      type="text"
                      name="name"
                      id="name"
                      className="bg-transparent border-2 rounded-lg py-4 px-3 w-full text-sm text-gray-900 border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                      {...register("name", {
                        required: "Please enter check name.",
                        minLength: {
                          value: 2,
                          message: "Minimum length must be 2.",
                        },
                        maxLength: {
                          value: 100,
                          message: "Maximum character can be 100.",
                        },
                      })}
                    />
                    <label
                      htmlFor="name"
                      className="text-sm text-[#A5A5A5] dark:text-gray-400 peer-focus:font-normal absolute duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("CHECK_NAME")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.name?.message} />
                  </div>

                  {/* Price */}
                  <div className="relative z-0 mb-6 w-full">
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      name="price"
                      id="price"
                      className="bg-transparent border-2 rounded-lg py-4 px-3 w-full text-sm text-gray-900 border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                      {...register("price", {
                        required: "Please enter price.",
                        min: {
                          value: 0,
                          message: "Price cannot be negative.",
                        },
                        validate: (value) =>
                          !isNaN(value) || "Please enter a valid price.",
                      })}
                    />
                    <label
                      htmlFor="price"
                      className="text-sm text-[#A5A5A5] dark:text-gray-400 peer-focus:font-normal absolute duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("PRICE")} ($)
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.price?.message} />
                  </div>
                </div>
              </div>
              <div className="justify-center p-6 border-t flex items-center border-solid border-slate-200 rounded-b">
                <button
                  className="px-12 py-2.5 text-black bg-[#E1E1E1] font-normal text-sm outline-none focus:outline-none rounded mr-6 ease-linear transition-all duration-150"
                  onClick={() => setEditShowModal(false)}
                  type="button"
                >
                  {t("O_BACK")}
                </button>
                <button
                  className="bg-LightBlue text-white active:bg-emerald-600 font-normal rounded shadow hover:shadow-lg outline-none text-sm px-8 py-2.5 focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t("O_SAVE")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="fixed inset-0 opacity-25 z-40 bg-black" />
    </>
  );
};

export default EditBackgroundCheckPricing;